import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { format } from 'date-fns';
import {
  Box,
  Card, CardContent, CardActionArea,
  Typography,
  IconButton,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

import { Document, getDocumentThumb, getProductImage } from '@ivymobi/orbit-core';
import { filter } from 'lodash';
import { CloudDownload } from '@mui/icons-material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    doubleLine: {
      display: '-webkit-box',
      minHeight: '2.5rem',
      overflow: 'hidden',
      textOverflow: '-o-ellipsis-lastline',
      textOverflow: 'ellipsis',
      WebkitLineClamp: 2,
      lineClamp: 2,
      WebkitBoxOrient: 'vertical',
      fontWeight: 'bold',
      color: '#5E5E5E',
      wordBreak: 'break-all',
    },
  })
);

export interface DocumentGridItem {
  id: string;
  thumbnail: string;
  type: 'folder' | 'file',
  url: string;
  name: string;
  link: string;
  updatedAt: string;
}
interface DocumentProps {
  document: DocumentGridItem;
  isWarning: boolean;
  onMenuClick?: (e, id) => void;
  onClick?: (e, id: string) => void;
}
export function CatagrayGridCard(props: DocumentProps) {
  const { catagray, onMenuClick, onClick } = props;
  const {  cgId, thumbnail, cgName, link } = catagray;
  const id = catagray.type ==='catalog'?catagray.cgId:catagray.details.supplierAltPid
  const handleOnMenuClick = (e) => {
    onMenuClick(e, id);
  };
  const _item = {name:'', imgUrl:''};
  if (catagray.type ==='catalog') {
    _item.name = catagray.cgName?.zh;
    _item.imgUrl = getProductImage(catagray?.mime,'/images/catlog.svg');
  } else if (catagray.type==='product') {
    _item.name = catagray.details?.descriptionShort?.zh;
    _item.imgUrl = getProductImage(catagray?.mime,'/images/dproduct.svg');
  }
  const handleClick = (e) => onClick?.(e, id);
  const classes = useStyles();
  return (
    <Card style={{ backgroundColor: '#e3e3e380' }} elevation={0} >
      <CardActionArea 
        component={RouteLink} 
        to={catagray.type ==='catalog'?(catagray.moduletype?`/products/${catagray.id}/${catagray.moduletype}`:`/products/${catagray.id}`):`/productDetail/${catagray.id}` }
        // disabled={isDisabled} 
        onClick={handleClick} 
      >
        <CardContent
          style={{
            display: 'flex', justifyContent: 'flex-start', alignItems: 'center',
            padding: '12px 0 12px 16px',
          }}
        >
          <img src={_item.imgUrl} style={{ height: '50px', width: '50px', marginRight: '12px' }} />
          <Box display="flex" flexDirection="column" overflow="hidden" flex={1} >
            <Typography variant='body2' className={classes.doubleLine}>{_item.name}</Typography>
            <Typography variant="caption" color="textSecondary" style={{visibility:'hidden'}}>
           111
            </Typography>
          </Box>
          <IconButton onClick={handleOnMenuClick} size="large">
            <MoreHoriz />
          </IconButton>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
export function DocumentGridCard(props: DocumentProps) {
  const { document, isWarning, onMenuClick, onClick,bDownload,onDownloadAction } = props;
  const { id, thumbnail, name, link, updatedAt } = document;
  const handleOnMenuClick = (e) => {
    onMenuClick(e, id);
  };
  // console.log('grid link ==== ', link)
  const handleClick = (e) => onClick?.(e, id);
  const classes = useStyles();
  return (
    <Card style={{ backgroundColor: '#e3e3e380' }} elevation={0} >
      <CardActionArea 
        component={RouteLink} 
        to={link}
        // disabled={isDisabled} 
        onClick={handleClick} 
      >
        <CardContent
          style={{
            display: 'flex', justifyContent: 'flex-start', alignItems: 'center',
            padding: '12px 0 12px 16px',
          }}
        >
          <img src={thumbnail} style={{ height: '50px', width: '50px', marginRight: '12px' }} />
          <Box display="flex" flexDirection="column" overflow="hidden" flex={1} >
            <Typography variant='body2' className={classes.doubleLine}>{name}</Typography>
            {updatedAt && <Typography variant="caption" color="textSecondary">
              {format(new Date(updatedAt), 'yyyy-MM-dd')}
            </Typography>}
          </Box>
          {!isWarning && <IconButton onClick={handleOnMenuClick} size="large">
            <MoreHoriz />
          </IconButton>}
          {isWarning && bDownload && document.type==='file'&& <IconButton
            onClick={(e)=>{
              e.stopPropagation();
              e.preventDefault();
              if(onDownloadAction){
                onDownloadAction(document)
              }
              //window.open(document.asset.url,"_blank");                 


            }}
            size="large">
              <CloudDownload />
          </IconButton>}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export function DocumentGridList(props: DocumentProps) {
  const { document, isWarning, onMenuClick, onClick } = props;

  const { id, thumbnail, name, link, updatedAt } = document;
  // console.log('thumbnailthumbnailthumbnailthumbnail');
  // console.log(thumbnail);
  const handleOnMenuClick = (e) => {
    onMenuClick(e, id);
  };

  const handleClick = (e) => onClick?.(e, id);
  const classes = useStyles();
  return (
    // <Card style={{ backgroundColor: '#e3e3e380' }} elevation={0} >
    //   <CardActionArea 
    //     component={RouteLink} 
    //     to={link}
    //     // disabled={isDisabled} 
    //     onClick={handleClick} 
    //   >
    //     <CardContent
    //       style={{
    //         display: 'flex', justifyContent: 'flex-start', alignItems: 'center',
    //         padding: '12px 0 12px 16px',
    //       }}
    //     >
    //       <img src={thumbnail} style={{ height: '50px', width: '50px', marginRight: '12px' }} />
    //       <Box display="flex" flexDirection="column" overflow="hidden" flex={1} >
    //         <Typography variant='body2' className={classes.doubleLine}>{name}</Typography>
    //         <Typography variant="caption" color="textSecondary">
    //           {format(new Date(updatedAt), 'yyyy-MM-dd')}
    //         </Typography>
    //       </Box>
    //       {!isWarning && <IconButton onClick={handleOnMenuClick}>
    //         <MoreHoriz />
    //       </IconButton>}
    //     </CardContent>
    //   </CardActionArea>
    // </Card>
    <Card elevation={0} >
      <CardActionArea 
        component={RouteLink} 
        to={link}
        // disabled={isDisabled} 
        onClick={handleClick} 
      >
        <CardContent
          style={{
            display: 'flex', justifyContent: 'flex-start', alignItems: 'center',
            padding: 0, borderBottom: '1px solid #F6F6F6'
          }}
        >
          <img src={thumbnail} style={{ height: '30px', width: '30px', marginLeft: '12px', marginRight: '12px' }} />
          <Typography variant='subtitle2' style={{flex: 1}} >{name}</Typography>
          <Typography variant="caption" color="textSecondary">
            {format(new Date(updatedAt), 'yyyy-MM-dd')}
          </Typography>
          {/* <Box display="flex" flexDirection="column" overflow="hidden" flex={1} >
            
          </Box> */}
          {!isWarning && <IconButton onClick={handleOnMenuClick} size="large">
            <MoreHoriz />
          </IconButton>}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export function formatToGridItem(doc: Document) {
  return {
    ...doc, thumbnail: getDocumentThumb(doc),
    // link: `/favorites/${doc.id}`,
    link: `/documents/${doc.id}`,
  };
}
